import uniqBy from 'lodash.uniqby';
import { conversationsConstants } from '@constants/conversations';

const initialState = {
    data: [],
    loading: true,
    pageToken: null,
    counters: {},
    archived: 0,
    archivedLoading: true,
};

export function conversations(state = initialState, action) {
    switch (action.type) {
        case conversationsConstants.CONVERSATIONS_FETCH:
            return { ...state, loading: true, pageToken: null };
        case conversationsConstants.CONVERSATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                pageToken: action.payload.nextPageToken,
                data: action.payload.items,
            };
        case conversationsConstants.CONVERSATIONS_LOAD_MORE_SUCCESS:
            return {
                ...state,
                data: uniqBy([...state.data, ...action.payload.items], 'id'),
                pageToken: action.payload.nextPageToken,
            };
        case conversationsConstants.CONVERSATIONS_COUNTERS_SUCCESS:
            return { ...state, counters: action.payload };
        case conversationsConstants.CONVERSATIONS_ERROR:
            return { ...state, loading: false };
        case conversationsConstants.CONVERSATIONS_UPDATE:
            return { ...state, data: action.data };
        case conversationsConstants.CONVERSATIONS_ARCHIVED_SUCCESS:
            return { ...state, archived: action.payload.count, archivedLoading: false };
        case conversationsConstants.CONVERSATIONS_RESET:
            return initialState;
        default:
            return state;
    }
}
